import React from "react";
// @material-ui/core components
import { useTheme } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import Grid from "@material-ui/core/Grid";
import LinearProgress from "@material-ui/core/LinearProgress";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Typography from "@material-ui/core/Typography";
// @material-ui/icons components

// core components
import boxShadows from "assets/theme/box-shadow.js";

function CardSocialTraffic() {
  const theme = useTheme();
  return (
    <>
      <Card
        sx={{
          boxShadow: boxShadows.boxShadow + "!important",
          border: "0!important",
        }}
      >
        <CardHeader
          subheader={
            <Grid
              container
              component={Box}
              sx={{ alignItems: "center", justifyContent: "space-between" }}
            >
              <Grid item xs="auto">
                <Box
                  component={Typography}
                  variant="h3"
                  sx={{ marginBottom: "0!important" }}
                >
                  Social traffic
                </Box>
              </Grid>
              <Grid item xs="auto">
                <Box
                  sx={{
                    justifyContent: "flex-end",
                    display: "flex",
                    flexWrap: "wrap",
                  }}
                >
                  <Button variant="contained" color="primary" size="small">
                    See all
                  </Button>
                </Box>
              </Grid>
            </Grid>
          }
          sx={{ backgroundColor: "initial!important" }}
        ></CardHeader>
        <TableContainer>
          <Box
            component={Table}
            sx={{ alignItems: "center", marginBottom: "0!important" }}
          >
            <TableHead>
              <TableRow>
                <TableCell
                  sx={{
                    verticalAlign: "middle",
                    paddingLeft: "1.5rem",
                    paddingRight: "1.5rem",
                    borderTop: "0",
                    backgroundColor: theme.palette.gray[100],
                    color: theme.palette.gray[600],
                    fontSize: ".65rem",
                  }}
                >
                  Refferal
                </TableCell>
                <TableCell
                  sx={{
                    verticalAlign: "middle",
                    paddingLeft: "1.5rem",
                    paddingRight: "1.5rem",
                    borderTop: "0",
                    backgroundColor: theme.palette.gray[100],
                    color: theme.palette.gray[600],
                    fontSize: ".65rem",
                  }}
                >
                  Visitors
                </TableCell>
                <TableCell
                  sx={{
                    verticalAlign: "middle",
                    paddingLeft: "1.5rem",
                    paddingRight: "1.5rem",
                    borderTop: "0",
                    backgroundColor: theme.palette.gray[100],
                    color: theme.palette.gray[600],
                  }}
                ></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell
                  sx={{
                    verticalAlign: "middle",
                    paddingLeft: "1.5rem",
                    paddingRight: "1.5rem",
                    borderTop: "0",
                    textTransform: "unset!important",
                    fontSize: ".8125rem",
                  }}
                  component="th"
                  variant="head"
                  scope="row"
                >
                  Facebook
                </TableCell>
                <TableCell
                  sx={{
                    verticalAlign: "middle",
                    paddingLeft: "1.5rem",
                    paddingRight: "1.5rem",
                    borderTop: "0",
                  }}
                >
                  1,480
                </TableCell>
                <TableCell
                  sx={{
                    verticalAlign: "middle",
                    paddingLeft: "1.5rem",
                    paddingRight: "1.5rem",
                    borderTop: "0",
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Box component="span" sx={{ marginRight: ".5rem" }}>
                      60%
                    </Box>
                    <LinearProgress
                      variant="determinate"
                      value={60}
                      sx={{
                        height: "3px!important",
                        width: "120px!important",
                        margin: "0!important",
                        "& .MuiLinearProgress-bar": {
                          background:
                            "linear-gradient(87deg," +
                            theme.palette.error.main +
                            ",#f56036)!important",
                        },
                      }}
                    />
                  </Box>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  sx={{
                    verticalAlign: "middle",
                    paddingLeft: "1.5rem",
                    paddingRight: "1.5rem",
                    borderTop: "0",
                    textTransform: "unset!important",
                    fontSize: ".8125rem",
                  }}
                  component="th"
                  variant="head"
                  scope="row"
                >
                  Facebook
                </TableCell>
                <TableCell
                  sx={{
                    verticalAlign: "middle",
                    paddingLeft: "1.5rem",
                    paddingRight: "1.5rem",
                    borderTop: "0",
                  }}
                >
                  5,480
                </TableCell>
                <TableCell
                  sx={{
                    verticalAlign: "middle",
                    paddingLeft: "1.5rem",
                    paddingRight: "1.5rem",
                    borderTop: "0",
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Box component="span" sx={{ marginRight: ".5rem" }}>
                      70%
                    </Box>
                    <Box sx={{ width: "100%" }}>
                      <LinearProgress
                        variant="determinate"
                        value={70}
                        sx={{
                          height: "3px!important",
                          width: "120px!important",
                          margin: "0!important",
                          "& .MuiLinearProgress-bar": {
                            background:
                              "linear-gradient(87deg," +
                              theme.palette.success.main +
                              ",#2dcecc)!important",
                          },
                        }}
                      />
                    </Box>
                  </Box>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  sx={{
                    verticalAlign: "middle",
                    paddingLeft: "1.5rem",
                    paddingRight: "1.5rem",
                    borderTop: "0",
                    textTransform: "unset!important",
                    fontSize: ".8125rem",
                  }}
                  component="th"
                  variant="head"
                  scope="row"
                >
                  Google
                </TableCell>
                <TableCell
                  sx={{
                    verticalAlign: "middle",
                    paddingLeft: "1.5rem",
                    paddingRight: "1.5rem",
                    borderTop: "0",
                  }}
                >
                  4,807
                </TableCell>
                <TableCell
                  sx={{
                    verticalAlign: "middle",
                    paddingLeft: "1.5rem",
                    paddingRight: "1.5rem",
                    borderTop: "0",
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Box component="span" sx={{ marginRight: ".5rem" }}>
                      80%
                    </Box>
                    <Box sx={{ width: "100%" }}>
                      <LinearProgress
                        variant="determinate"
                        value={80}
                        sx={{
                          height: "3px!important",
                          width: "120px!important",
                          margin: "0!important",
                          "& .MuiLinearProgress-bar": {
                            background:
                              "linear-gradient(87deg," +
                              theme.palette.primary.main +
                              ",#825ee4)!important",
                          },
                        }}
                      />
                    </Box>
                  </Box>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  sx={{
                    verticalAlign: "middle",
                    paddingLeft: "1.5rem",
                    paddingRight: "1.5rem",
                    borderTop: "0",
                    textTransform: "unset!important",
                    fontSize: ".8125rem",
                  }}
                  component="th"
                  variant="head"
                  scope="row"
                >
                  Instagram
                </TableCell>
                <TableCell
                  sx={{
                    verticalAlign: "middle",
                    paddingLeft: "1.5rem",
                    paddingRight: "1.5rem",
                    borderTop: "0",
                  }}
                >
                  3,678
                </TableCell>
                <TableCell
                  sx={{
                    verticalAlign: "middle",
                    paddingLeft: "1.5rem",
                    paddingRight: "1.5rem",
                    borderTop: "0",
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Box component="span" sx={{ marginRight: ".5rem" }}>
                      75%
                    </Box>
                    <Box sx={{ width: "100%" }}>
                      <LinearProgress
                        variant="determinate"
                        value={75}
                        sx={{
                          height: "3px!important",
                          width: "120px!important",
                          margin: "0!important",
                          "& .MuiLinearProgress-bar": {
                            background:
                              "linear-gradient(87deg," +
                              theme.palette.info.main +
                              ",#1171ef)!important",
                          },
                        }}
                      />
                    </Box>
                  </Box>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  sx={{
                    verticalAlign: "middle",
                    paddingLeft: "1.5rem",
                    paddingRight: "1.5rem",
                    borderTop: "0",
                    textTransform: "unset!important",
                    fontSize: ".8125rem",
                    borderBottom: "0!important",
                  }}
                  component="th"
                  variant="head"
                  scope="row"
                >
                  twitter
                </TableCell>
                <TableCell
                  sx={{
                    verticalAlign: "middle",
                    paddingLeft: "1.5rem",
                    paddingRight: "1.5rem",
                    borderTop: "0",
                    borderBottom: "0!important",
                  }}
                >
                  2,645
                </TableCell>
                <TableCell
                  sx={{
                    verticalAlign: "middle",
                    paddingLeft: "1.5rem",
                    paddingRight: "1.5rem",
                    borderTop: "0",
                    borderBottom: "0!important",
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Box component="span" sx={{ marginRight: ".5rem" }}>
                      30%
                    </Box>
                    <Box sx={{ width: "100%" }}>
                      <LinearProgress
                        variant="determinate"
                        value={30}
                        sx={{
                          height: "3px!important",
                          width: "120px!important",
                          margin: "0!important",
                          "& .MuiLinearProgress-bar": {
                            background:
                              "linear-gradient(87deg," +
                              theme.palette.warning.main +
                              ",#fbb140)!important",
                          },
                        }}
                      />
                    </Box>
                  </Box>
                </TableCell>
              </TableRow>
            </TableBody>
          </Box>
        </TableContainer>
      </Card>
    </>
  );
}

export default CardSocialTraffic;
